export default __webpack_public_path__ + "static/media/Street.73948584.png";